import { Icon } from '@iconify/react';
import { Box, Button, CircularProgress, Divider, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../Base';
import { displayNumber } from '../../consts/helpers';
import CarbonEmissionEffectCard from '../cards/CarbonEmissionEffectCard';
import ResultGaugeChart from '../charts/ResultGaugeChart';

export default function ResultsStage2({ callCalcAPI, handleProceed }) {
    const navigate = useNavigate();
    const setFootprint = useContext(AppContext).setFootprint;
    
    const [result, setResult] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setResult('');
        setIsLoading(true);
        callCalcAPI().then( data => {
            setResult(data?.S2_emissions ? data?.S2_emissions*12 : 0);
            setFootprint(data?.S2_emissions ? data?.S2_emissions*12 : 0);
            setIsLoading(false);
        });
    }, [callCalcAPI, setFootprint]);

    return (
        <Box sx={{ flex: 'auto' }} className='spread-y'>
        <Stack spacing={3}>
            <Box>
            <Box className='centered-container' sx={{ borderRadius: 'var(--container-rad)', backgroundColor: 'var(--pri-purple)', p: 2, color: 'white', textAlign: 'center' }}>
                <Typography variant='body2'>
                    Your Annual Carbon Footprint<br/>
                    is estimated to be
                </Typography>
                <Typography variant='h5'>
                    <Icon icon="material-symbols:barefoot" color='var(--pri-green)'/>&nbsp;
                    { isLoading ?
                        <CircularProgress size={20} color='inherit' />
                        :
                        <>{displayNumber(result, 3)} tCO<sub>2</sub>e/year</>
                    }
                </Typography>
                <ResultGaugeChart resultValue={result} />
            </Box>
            
            <Box className='centered-container' sx={{ p: 2, fontStyle: 'italic' }}>
            <Typography variant='caption'>
                Note: Your estimated footprint may include contributions from certain lifestyle categories not directly mentioned here, such as health, education, and clothing. These are included to provide a complete estimate of your carbon footprint.
            </Typography>
            </Box>
            <Divider />
            </Box>
            
            <CarbonEmissionEffectCard />
        </Stack>
        <Stack spacing={2} sx={{ mt: 2 }}>
            <Typography variant="body2" fontSize={12} gutterBottom>
                Would you like to reduce your emissions?
            </Typography>
            <Button className="pill_btn pri_btn" onClick={handleProceed}>Yes</Button>
            <Button className="pill_btn pri_btn outline_btn" onClick={() => navigate('/feedback/form')}>No</Button> 
        </Stack>
        </Box>
    )
}